import React, { useEffect, useState } from 'react';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import Pagination from 'components/Pagination';
import { useHistory } from 'react-router-dom';
import ModalConfirmation from 'components/Modal/ConfirmationModal';
import ModalConfirmationCopy from './components/modalConfirmationCopy';
import ProfileService from '../service';
import { brazilian } from '../../../assets/translator/pt-br';

import {
  Input,
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';

const ProfileList = () => {
  const history = useHistory();
  const translatedBrazilianProfiles = brazilian.PROFILES;
  const [profiles, setProfiles] = useState([]);
  const [dataProfileCopy, setDataProfileCopy] = useState(null);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchProfiles, setSearchProfiles] = useState('');
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [openModalConfirmationCopy, setOpenModalConfirmationCopy] = useState(
    false
  );
  const [idResource, serIdResource] = useState();

  function handleUpdate(id) {
    history.push(`profile/form/${id}`);
  }

  const getProfiles = (selectedPage = 1, search = '') => {
    setLoading(true);
    ProfileService.getAllSeach(selectedPage, 10, search, true)
      .then((response) => {
        const profileList = response.data.data;

        const newProfileList = profileList.map((profile) => {
          if (translatedBrazilianProfiles[profile.name]) {
            profile.name = translatedBrazilianProfiles[profile.name];
            profile.disabledOperation = true;
          } else {
            profile.disabledOperation = false;
          }
          return profile;
        });

        const quantity = response.data.totalRegisters;

        setProfiles(newProfileList);
        setQuantity(quantity);
        setLoading(false);
      })
      .catch((err) => {
        //const { data } = error.response;
        toast.error(
          err.response.data.message || 'Erro ao listar perfis de acesso!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        setLoading(false);
      });
  };

  useEffect(getProfiles, [translatedBrazilianProfiles]);

  const getProfilesSearch = (event, selectedPage = 1) => {
    setSearchProfiles(event.target.value);
    if (searchProfiles) {
      getProfiles(selectedPage, event.target.value);
    }
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    getProfiles(page);
  };

  function deleteProfile(id) {
    ProfileService.delete(id)
      .then(() => {
        toast.success('Perfil de acesso excluído com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });
        getProfiles();
      })
      .catch((err) => {
        toast.error(
          err.response.data.message || 'Erro ao deletar perfil de acesso!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getProfiles();
      });
  }

  function controlDeleteResource(idResouce) {
    serIdResource(idResouce);
    setOpenModalConfirmation(true);
  }

  async function handleCloneProfile(profile) {
    try {
      const response = await ProfileService.get(profile.id);
      const data = response.data.data;
      setDataProfileCopy(data);
      setOpenModalConfirmationCopy(true);
    } catch (err) {
      console.log('erro', err);
    }
  }

  return (
    <>
      <SimpleHeader
        setCreate="/admin/profile/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row className="mt-3 mx-2">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Perfil de acesso</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Perfil de acesso"
                          type="text"
                          onChange={(event) => getProfilesSearch(event)}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={profiles}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'description',
                      text: 'Descrição',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            title={'Editar perfil'}
                            onClick={() => handleUpdate(row.id)}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            size="sm"
                            title={
                              row.disabledOperation
                                ? 'Não é possivel excluir perfil padrão do sistema'
                                : 'Excluir perfil'
                            }
                            disabled={row.disabledOperation}
                            onClick={() => controlDeleteResource(row.id)}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'clone',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Clonar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            title={'Clonar Perfil'}
                            onClick={() => handleCloneProfile(row)}
                          >
                            <li className="fas fa-clone"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteProfile}
        message={'Tem certeza que deseja excluir o perfil de acesso?'}
      />

      <ModalConfirmationCopy
        isModalOpen={openModalConfirmationCopy}
        onModalToggle={setOpenModalConfirmationCopy}
        unmountOnClose={true}
        ProfileCopy={dataProfileCopy}
        getProfiles={getProfiles}
      />
    </>
  );
};

export default ProfileList;
